import TopSellingCard from '@base/components/src/Cards/TopSellingCard';
import { ResponsiveCarousel } from '@base/components/src/Carousel';
import Image from '@base/components/src/Image';
import Link from '@base/components/src/Link';
import { Underline } from '@base/components/src/Link/types';
import useMediaQuery from '@package/hooks/src/useMediaQuery';
import useTopSellingsProducts from '@package/hooks/src/useTopSellingsProducts';
import { TopSellingProduct } from '@package/services/src/Algonomy/types';
import config from 'config-base';
import clsx from 'clsx';
import styles from './CartEmptyState.module.css';

const CartEmptyState = () => {
  const { topSellingProducts } = useTopSellingsProducts();
  const mobile: boolean = useMediaQuery('(max-width:1279px)');
  return (
    <>
      <section id="cart-empty-page" className={styles.cartEmpty}>
        <h1 className={styles.emptyTitle}>Your shopping cart is empty</h1>
        <div className={styles.cartImage}>
          <Image layout="fill" src="/marketplace-static/images/icons/shoping-cart-empty.svg" alt="shoppin-cart-empty" />
        </div>
        <p className={styles.emptyDescription}>
          Please{' '}
          <Link
            data-testid={'my-account-url'}
            showCursorPointer
            href={config.myAccountUrl}
            classes={clsx(styles.emptyLink, config.brandCode === '2' && styles.emptyLinkAGD)}
            underline={Underline.always}
          >
            log into
          </Link>
          {` your account to view any items that were added to your cart from a previous visit. If you are not a ${
            config.brandCode === '2' ? 'Airgun Depot' : 'Pyramyd AIR'
          } customer please `}
          <Link
            data-testid={'create-account-url'}
            showCursorPointer
            href={config.createAccountUrl}
            classes={clsx(styles.emptyLink, config.brandCode === '2' && styles.emptyLinkAGD)}
            underline={Underline.always}
          >
            sign up here!
          </Link>
        </p>
      </section>
      {topSellingProducts && topSellingProducts?.length > 0 && (
        <section className={clsx(styles.topSellings, config.brandCode === '2' && styles.topSellingsAGD)}>
          <h2 className={clsx(styles.trending, config.brandCode === '2' && styles.trendingAGD)}>
            Top-Selling Products
          </h2>
          <div
            className={clsx(
              styles.topSellingsCarousel,
              {
                'bg-secondary-second': config.brandCode === '0',
              },
              {
                'bg-white': config.brandCode !== '0',
              },
            )}
          >
            <ResponsiveCarousel<TopSellingProduct>
              slideData={topSellingProducts}
              buttonsAbsolute
              hideDotButtons={!mobile}
              dragEnabled={false}
              touchEnabled={false}
              visibleSlidesQuery={{
                xxl: 5,
                xl: 4,
                lg: 3,
                md: 3,
                sm: 2,
                xs: 2,
              }}
              renderSlide={(popular: TopSellingProduct, idx: number) => (
                <TopSellingCard
                  searchItem={popular}
                  idx={idx}
                  imageClasses={clsx(
                    styles.cartEmptyStateCardImage,
                    config.brandCode === '2' && styles.cartEmptyStateCardImageAGD,
                  )}
                />
              )}
              carouselPadding={styles.cartEmptyStatePadding}
              carouselHeight={styles.cartEmptyStateHeight}
              slideContentClassName={styles.slideContent}
              dotClassName={styles.dots}
              dragStep={mobile ? 2 : 5}
            />
          </div>
        </section>
      )}
    </>
  );
};

export default CartEmptyState;
